<template>
  <div id="app" ref="app" v-if="show">
    <router-view />
  </div>
</template>
<script>
import { GetSystemInfo, getCommonEnums } from "@/api/baseData";
export default {
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    window.vue_this = this;
    GetSystemInfo().then((res) => {
      window.SystemInfo = res.result;
      $("title").html(window.SystemInfo.title);
      this.show = true;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue